import NameChange from './components/NameChange';
import CounterFour from './components/CounterFour';
import CounterOne from './components/CounterOne';
import CounterThree from './components/CounterThree';
import CounterTwo from './components/CounterTwo';
import CounterFive from './components/CounterFive';

function App() {
  return (
    <>
      <NameChange />
      <CounterOne />
      <CounterTwo />
      <CounterThree />
      <CounterFour />
      <CounterFive/>
    </>
  );
}

export default App;
